<template>

    <v-card class="pa-4" elevation="10" shaped outlined>
      <h3 class="text-right my-4">گزارش وجوه پرداخت شده</h3>
      <v-row>
        <v-col cols="12" sm="6" md="3" lg="3">
          <v-autocomplete
            dense
            v-model="GW"
            label="درگاه"
            :items="GWDDLList"
            item-text="Title"
            :clearable="false"
            item-value="ID"
            no-data-text="هیچ موردی یافت نشد."
            @change="sendGW"
          ></v-autocomplete>
        </v-col>

        <v-col cols="12" sm="6" md="3" lg="3">
          <v-autocomplete
            dense
            v-model="TerminalID"
            label="بابت"
            :items="groupDDLList"
            item-text="Name"
            :clearable="false"
            item-value="ID"
            no-data-text="هیچ موردی یافت نشد."
          ></v-autocomplete>
        </v-col>

        <v-col cols="12" sm="6" md="3" lg="3">
          <v-text-field
            dense
            v-model="username"
            label="نام کاربری"
            @change="updateReports"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" md="3" lg="3">
          <v-text-field
            dense
            v-model="password"
            label="کلمه عبور"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required]"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
            @change="updateReports"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row >
<!--        <v-col cols="12" sm="4" md="3" lg="3" xl="4">-->
<!--          <label for="startDate">از تاریخ</label>-->

<!--          <date-picker-->
<!--            color="black"-->
<!--            id="startDate"-->
<!--            type="date"-->
<!--            v-model="startOn"-->
<!--            format="YYYY-MM-DD"-->
<!--            :editable="true"-->
<!--            display-format="jYYYY-jMM-jDD"-->
<!--            :timezone="true"-->
<!--          />-->
<!--        </v-col>-->

<!--        <v-col cols="12" sm="4" md="3" lg="3">-->
<!--          <label for="startDate">تا تاریخ</label>-->

<!--          <date-picker-->
<!--            color="black"-->
<!--            id="startDate"-->
<!--            type="date"-->
<!--            v-model="EndOn"-->
<!--            format="YYYY-MM-DD"-->
<!--            :editable="true"-->
<!--            display-format="jYYYY-jMM-jDD"-->
<!--            :timezone="true"-->
<!--          />-->
<!--        </v-col>-->
        <v-col cols="12" sm="4" md="3" lg="3" xl="4">
        <v-text-field
            dense
            label="از تاریخ"
            type="text"
            class="form-control form-control-lg"
            id="my-custom-input"
            v-model="j_date_from1"
        ></v-text-field>

          <date-picker
              color="black"
              v-model="j_date_from1"
              format="jYYYY/jMM/jDD"
              element="my-custom-input"
              required
              @change="StartOn=$event.format('YYYY-MM-DD')"
          />
        </v-col>



        <v-col cols="12" sm="4" md="3" lg="3" xl="4">
        <v-text-field
            dense
            label="تا تاریخ"
            type="text"
            class="form-control form-control-lg"
            v-model="j_date_to1"
            id="my-custom-input1"
        ></v-text-field>

        <date-picker
            color="black"
            v-model="j_date_to1"
            format="jYYYY/jMM/jDD"
            element="my-custom-input1"
            required
            @change="EndOn=$event.format('YYYY-MM-DD')"
        />
        </v-col>



        <v-col cols="12" sm="4" md="3" lg="3" class="mt-4">
          <v-btn
              color="primary"
              dark
              medium
              @click="sendInfo"
              class="mx-3"
              rounded
          >
            جستجو
          </v-btn>
        </v-col>

        <v-col cols="12" sm="3" md="3" lg="3" class="mt-4">
          <v-btn
              color="primary"
              dark
              medium
              @click="sendInfo2"
              class="mx-3"
              rounded
              outlined
          >
دانلود <v-icon
              medium
              color="primary"
          >
            mdi-arrow-down-bold-box
          </v-icon>
          </v-btn>
        </v-col>
      </v-row>



      <v-row>
        <v-col  cols="12" sm="4" md="3" lg="3" class="ml-auto" v-if="Number(sum).toLocaleString() !=0  && reports && reports.length !== 0">
          <v-chip class="grey lighten-2">
            جمع: {{ Number(sum).toLocaleString() }}
          </v-chip>
        </v-col>
      </v-row>
      <br />

      <div class="text-center">
        <template v-if="pagination.count > pagination.take && reports && reports.length !== 0" class="ma-4">
          <v-pagination
            :length="Math.ceil(pagination.count / take)"
            v-model="pageNumber"
            :next="next"
            :previous="previous"
            :total-visible="7"
          ></v-pagination>
        </template>
      </div>
      <v-simple-table class="table "  v-if="reports && reports.length !== 0">
        <template >
          <thead>
            <tr>
              <th class="text-center T-head">OrderID</th>
              <th class="text-center T-head">زمان درخواست</th>
              <th class="text-center T-head">کد ملی</th>
              <th class="text-center T-head">نام و نام خانوادگی</th>
              <th class="text-center T-head">تماس</th>
              <th class="text-center T-head">نتیجه</th>
              <th class="text-center T-head">مبلغ (ریال)</th>
              <th class="text-center T-head">شناسه تراکنش</th>
            </tr>
          </thead>
          <tbody>
            <tr   v-for="(report, index) in reports" :key="index">
              <td>{{ report.OrderID }}</td>
              <td>{{ report.CreateOn }}</td>
              <td>{{ report.NC }}</td>
              <td>{{ report.Name }} {{ report.Family }}</td>
              <td>{{ report.Mobile }}</td>
              <td>
                <template
                  v-if="
                    report.Status &&
                    report.Status.charAt(0) === '0' &&
                    report.Status.charAt(1) === ':'
                  "
                >
                  <v-icon color="green" small>
                    mdi-checkbox-marked-circle
                  </v-icon>
                </template>
                <template v-else>
                  <v-icon color="red" small> mdi-cancel </v-icon>
                </template>
              </td>
              <td>{{ Number(report.amount).toLocaleString() }}</td>
              <td>{{ report.CN }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <div class="text-center">
        <template v-if="pagination.count > pagination.take  && reports && reports.length !== 0" class="ma-4">
          <v-pagination
            :length="Math.ceil(pagination.count / take)"
            v-model="pageNumber"
            :next="next"
            :previous="previous"
            :total-visible="7"
          ></v-pagination>
        </template>
      </div>
<!--      loading overlay-->
      <v-overlay :value="loadReportIsLoading==='Owner_Report'|| loadReportIsLoading==='Owner_Group_DDL'|| loadReportIsLoading==='Owner_GW_DDL'">
        <v-progress-circular
            indeterminate
            size="64"
        ></v-progress-circular>
      </v-overlay>
      <!--      loading overlay-->

    </v-card>

</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Report",
  data: () => ({
    j_date_from1 : "",
    j_date_to1 : '',
    page: 1,
    pageNumber: 1,
    take: 10,
    GW: "",
    TerminalID: "",
    username: "",
    show: false,
    password: "",
    rules: {
      required: (value) => !!value || "کلمه عبور اجباری است.",
    },
    // startOn: getCurrentDate(-2),
    // EndOn: getCurrentDate(0),
    StartOn:"",
    EndOn:"",
    Download: false,
  }),

  computed: mapState({
    reports: (state) => state.reports,
    pagination: (state) => state.reportPagination,
    loadReportIsLoading: (state) => state.loadReportIsLoading,
    sum: (state) => state.sumOfPayments,
    GWDDLList: (state) => state.ownerGWDDL,
    groupDDLList: (state) => state.groupDDLList,
    list_for_download: (state) => state.list_for_download,

  }),
  created() {
    this.page = 1;
    this.pageNumber = 1;
    this.take = 10;
    this.GW = "";
    this.TerminalID = "";
    this.username = "";
    this.show = false;
    this.password = "";
    // this.startOn = getCurrentDate(-2);
    // this.EndOn = getCurrentDate(0);
    this.StartOn = "";
    this.EndOn = "";
    this.$store.commit("updateReports", {"reposts": []});
    this.$store.commit("updateReportPagination", { count: 0} );
    this.$store.commit("updateSumOfPayments", { sum: 0} )


    this.$store.commit("pushQueue", {
      functionName: "Owner_GW_DDL",
      data: {},
    });

    window.console.log("in Report.vue, $route is:");
    window.console.log(this.$route);

    //Set dates  default values

    let option = {year:"numeric",month:"2-digit",day:"2-digit"};
    let one_month_ago =(new Date( new Date().getFullYear(), new Date().getMonth()-1, new Date().getDate()));
    this.StartOn=this.persian2en_number(one_month_ago.toLocaleDateString('en-GB',option).split("/").reverse().join("-"));
    this.j_date_from1=this.persian2en_number(one_month_ago.toLocaleDateString('fa-IR',option));
    this.j_date_to1=this.persian2en_number((new Date( new Date().getFullYear(), new Date().getMonth(), new Date().getDate())).toLocaleDateString('fa-IR',option));
    // this.EndOn=this.persian2en_number((new Date( new Date().getFullYear(), new Date().getMonth(), new Date().getDate())).toLocaleDateString('en-GB',option).split("/").reverse().join("-"));
    this.EndOn=this.persian2en_number((new Date( new Date().getFullYear(), new Date().getMonth(), new Date().getDate())).toLocaleDateString('en-GB',option).split("/").reverse().join("-"));
  },
  methods: {
    convertToCSV:function(objArray) {

      var str = "";

      // Generate header row
      Object
          .keys(objArray[0])
          .forEach(function (key) {
            str += "," + key;
          });
      // remove first ","
      str = str.substring(1) + "\r\n";

      // Generate data rows
      for (var i = 0; i < objArray.length; i++) {
        var line = "";
        for (var index in objArray[i])
          line += "," + objArray[i][index];
        str += line.substring(1) + "\r\n";
      }

      return str;
    },
    persian2en_number:function (str){
      let persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
      let arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
      if (typeof str === 'string') {
        for (var i = 0; i < 10; i++) {
          str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
        }
      }
      return str;

    },
    previous: () => this.pageNumber--,
    reset: function() {
      this.$store.commit("updateReports", {"reposts": []});
      this.$store.commit('updateReportPagination', { "count": 0 });
      this.$store.commit("updateSumOfPayments", { sum: 0} );
    },
    next: () => this.pageNumber++,
    sendGW() {
      if (this.GW===null){
        this.TerminalID=""
      }else {
        this.reset();
        this.$store.commit("pushQueue", {
          functionName: "Owner_Group_DDL",
          data: {
            GWID: this.GW
          },
        });
      }

    },
    sendInfo() {
      this.reset();
      // window.console.log(this.EndOn);
      window.console.log(`sendInfo is called.`);
      this.page = 1;
      this.pageNumber = 1;
      this.$store.commit("pushQueue", {
        functionName: "Owner_Report",
        data: {
          Page: this.page,
          Take: this.take,
          GWID: this.GW,
          TerminalID: this.TerminalID,
          Username: this.username,
          Password: this.password,
          StartOn: this.StartOn,
          EndOn: this.EndOn,
          Download: this.Download,
        },
      });
    },
    sendInfo2() {
      //this.reset();
      window.console.log(`sendInfo2 is called.`);
      this.Download = true;
      this.$store.commit("pushQueue", {
        functionName: "Owner_Report",
        data: {
          Page: this.page,
          Take: this.take,
          GWID: this.GW,
          TerminalID: this.TerminalID,
          Username: this.username,
          Password: this.password,
          StartOn: this.StartOn,
          EndOn: this.EndOn,
          Download: this.Download,
        },
      });
      this.Download = false;
    },
    updateReports: function() {
      this.reset();
    }
  },
  watch: {
    // j_date_from: function(newValue){
    //   if(newValue === null || newValue === "" ){
    //     this.keySearchPayment.StartOn = '';
    //   }else{
    //     this.StartOn = newValue.format('YYYY-MM-DD');
    //   }
    // },
    list_for_download:function (){
      // simulate download
      if(typeof (this.list_for_download)!=='undefined'){
      let vm =this;
      let link = document.createElement('a');
      let x=this.convertToCSV(vm.list_for_download);
      let blob = new Blob([x], { type: 'application/octet-stream' });
      link.href = window.URL.createObjectURL(blob);
      link.download = "report.csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // $('#Output').text("Download starting ...");
      }
    },
    pageNumber() {
      window.console.log(`In watch Section, pageNumber is:`);
      window.console.log(this.pageNumber);
      this.Download = false;
      this.$store.commit("pushQueue", {
        functionName: "Owner_Report",
        data: {
          Page: this.pageNumber,
          Take: this.pagination.take,
          GWID: this.GW,
          TerminalID: this.TerminalID,
          Username: this.username,
          Password: this.password,
          StartOn: this.StartOn,
          EndOn: this.EndOn,
          Download: this.Download,
        },
      });
    },
  },
};
</script>

<style scoped>
tbody tr:nth-of-type(odd) {
  background-color: rgba(200, 200, 200, 0.1);
}
tbody td {
  font-size: 80% !important;
}
.paginate_section{
  margin: 20px 0;
}
.table {
  justify-content: center;
  border: 1px solid #ededed;
}
.T-head{
  color: black!important;
  font-size:small !important;
}
.table td{
  direction: ltr!important;
}
</style>
